/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sold_1Inputs */

const en_sold_1 = /** @type {(inputs: Sold_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sold`)
};

const es_sold_1 = /** @type {(inputs: Sold_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendido`)
};

const fr_sold_1 = /** @type {(inputs: Sold_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendue`)
};

const de_sold_1 = /** @type {(inputs: Sold_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkauft`)
};

const ja_sold_1 = /** @type {(inputs: Sold_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`売却済み`)
};

const zh_sold_1 = /** @type {(inputs: Sold_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已售出`)
};

const ar_sold_1 = /** @type {(inputs: Sold_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مباع`)
};

const id_sold_1 = /** @type {(inputs: Sold_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terjual`)
};

const it_sold_1 = /** @type {(inputs: Sold_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venduto`)
};

const ru_sold_1 = /** @type {(inputs: Sold_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продано`)
};

const pt_sold_1 = /** @type {(inputs: Sold_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendido`)
};

const ko_sold_1 = /** @type {(inputs: Sold_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`판매 완료`)
};

/**
* | output |
* | --- |
* | "Sold" |
*
* @param {Sold_1Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sold_1 = /** @type {((inputs?: Sold_1Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sold_1Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sold_1(inputs)
	if (locale === "es") return es_sold_1(inputs)
	if (locale === "fr") return fr_sold_1(inputs)
	if (locale === "de") return de_sold_1(inputs)
	if (locale === "ja") return ja_sold_1(inputs)
	if (locale === "zh") return zh_sold_1(inputs)
	if (locale === "ar") return ar_sold_1(inputs)
	if (locale === "id") return id_sold_1(inputs)
	if (locale === "it") return it_sold_1(inputs)
	if (locale === "ru") return ru_sold_1(inputs)
	if (locale === "pt") return pt_sold_1(inputs)
	return ko_sold_1(inputs)
});